import React from "react";
import { TextField } from "@mui/material";

const CardOwnerInfo = ({cardOwnerInfo, setCardOwnerInfo}) => {
  return (
    <>
      <div className="font-size-20 font-weight-bold mt-2">
        Карт Эзэмшигчийн Мэдээлэл
      </div>
      <TextField 
        className="mt-3 w-100 dialog-inputs" 
        label="Нэр" 
        variant="outlined"
        value={cardOwnerInfo.name ?? ''}
        onChange={(e) => setCardOwnerInfo({...cardOwnerInfo, name: e.target.value})}
      /> 
      <TextField 
        className="mt-3 w-100 dialog-inputs" 
        label="Утасны дугаар" 
        variant="outlined"
        value={cardOwnerInfo.phone ?? ''}
        onChange={(e) => setCardOwnerInfo({...cardOwnerInfo, phone: e.target.value})}
      /> 
      <div className="font-size-20 font-weight-bold mt-5">
        Машины Мэдээлэл
      </div>
      <TextField 
        className="mt-3 w-100 dialog-inputs" 
        label="Машины дугаар" 
        variant="outlined"
        value={cardOwnerInfo.plate ?? ''}
        onChange={(e) => setCardOwnerInfo({...cardOwnerInfo, plate: e.target.value})}
      /> 
      <div className="font-size-20 font-weight-bold mt-5">
        Нэмэлт хүснэгт
      </div>
      <div className="bordered-input form-item-small-height px-2 mt-3 d-flex align-items-center text-grey font-size-16">
        <i className='bx bx-plus ms-2'></i> Багана
      </div>
      <TextField 
        className="mt-3 w-100 dialog-inputs" 
        label="Өгөгдөл" 
        variant="outlined"
      /> 
    </>
  )
}
  
export default CardOwnerInfo